import { useRef } from "react";
import PropTypes from "prop-types";
// form
import { FormProvider as Form } from "react-hook-form";
import { SaveBar } from "@shopify/app-bridge-react";

let formIdCounter = 0;

FormProvider.propTypes = {
  children: PropTypes.node.isRequired,
  methods: PropTypes.object.isRequired,
  onSubmit: PropTypes.func,
  showSaveBar: PropTypes.bool,
  hasUnsavedChanges: PropTypes.bool,
};

export default function FormProvider({ children, onSubmit, methods, showSaveBar = undefined, hasUnsavedChanges }) {
  const formIdRef = useRef(null);
  if (formIdRef.current === null) formIdRef.current = `form-save-bar-${++formIdCounter}`;
  const formId = formIdRef.current;

  const isDirty = hasUnsavedChanges ?? methods.formState.isDirty;

  const handleReset = () => {
    methods.reset();
  };

  return (
    <Form {...methods}>
      {showSaveBar && (
        <SaveBar open={isDirty}>
          <button variant="primary" type="submit" form={formId} />
          <button type="reset" form={formId} />
        </SaveBar>
      )}
      <form id={formId} onSubmit={onSubmit} onReset={handleReset} noValidate>
        {children}
      </form>
    </Form>
  );
}
